export default __webpack_public_path__ + "static/media/loginImg.71e6566a.jpg";